/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_StarredInputs */

const en_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred`)
};

const fr_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoris`)
};

const de_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Sternchen`)
};

const it_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con stella`)
};

const ru_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмечено звездочкой`)
};

const es_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembrado de estrellas`)
};

const zh_cn2_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`星标`)
};

const ja_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スター付き`)
};

const hi_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारांकित`)
};

const pt_pt2_explorer_nav_starred = /** @type {(inputs: Explorer_Nav_StarredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrelado`)
};

/**
* | output |
* | --- |
* | "Starred" |
*
* @param {Explorer_Nav_StarredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_starred = /** @type {((inputs?: Explorer_Nav_StarredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_StarredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_starred(inputs)
	if (locale === "de") return de_explorer_nav_starred(inputs)
	if (locale === "it") return it_explorer_nav_starred(inputs)
	if (locale === "ru") return ru_explorer_nav_starred(inputs)
	if (locale === "es") return es_explorer_nav_starred(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_starred(inputs)
	if (locale === "ja") return ja_explorer_nav_starred(inputs)
	if (locale === "hi") return hi_explorer_nav_starred(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_starred(inputs)
	return en_explorer_nav_starred(inputs)
});